module.exports = __webpack_public_path__ + "img/JDapprovalgrey.9cc6b501.svg";